// extracted by mini-css-extract-plugin
export default {"BtnWrap":"UndoRedoButtons_BtnWrap__++tsv","margin":"UndoRedoButtons_margin__xlODa"};